import classNames from 'classnames';
import styled from 'styled-components';
import { deviceSizes } from '../../style';
import Icon from '../icon';
import { Box, BoxProps } from '../box';
import { SquareButtonProps } from '../button/square-button';
import { SquareButton } from '../button';

export const StickyBlockModalComponent = ({ children, className, ...rest }: BoxProps) => (
  <Box className={classNames('box-sticky-block-modal', className)} {...rest}>
    {children}
  </Box>
);

const StyledStickyBlockModal = styled(StickyBlockModalComponent)<BoxProps>`
  &.box-sticky-block-modal {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    right: 0;
    transition: transform 0.3s;
    z-index: 9999;
    box-shadow: 0 8px 24px 10px rgba(0, 0, 0, 0.12);
    background: white;
    border-top: 1px solid #e6e6e6;

    .title {
      margin-top: 23px;

      @media (max-width: ${deviceSizes.sm}) {
        margin-top: 10px;
      }

      @media (max-width: ${deviceSizes.sm}) {
        margin-top: 23px;
      }
    }

    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 3100;
    }

    @media (max-width: ${deviceSizes.sm}) {
      max-height: 165px;
    }
  }
`;

const StickyBlockModal = (props: BoxProps) => <StyledStickyBlockModal {...props} />;
StickyBlockModal.CloseButton = ({ onClick }: SquareButtonProps) => (
  <SquareButton className="close" aria-label={'close'} onClick={onClick}>
    <Icon name="CLOSE" />
  </SquareButton>
);

export default StickyBlockModal;
